// extracted by mini-css-extract-plugin
module.exports = {"layoutPadding":"g_r","main":"g_s g_r"};